/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import EventService from '../../../services/EventService';
import moment from "moment";
import ToastService from '../../../services/ToastService';
import { showLoading } from 'react-global-loading';

import shareicn from '../../../public/shareicn.svg';
import hearticn from '../../../public/hearticn.svg';
class EventDetails extends React.Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(this.props.location.search);
    showLoading(true);
    this.state = {
      eventDetails: {},
      buttonDisabled: this.props.history.location.pathname === '/country-event-details' ? true : false,
      eventId: query.get('id')
    };
  }

  componentDidMount = () => {
    this.getEventById(this.state.eventId);
  };

  getEventById = (id) => {
    EventService.getEventById({ "p": id })
      .then((result) => {
        if (!result) {
          return;
        }

        this.setState({ eventDetails: result[0] });

        showLoading(false);

      })
      .catch((err) => {
        console.error(err);
      });
  };

  onApproveDisapproveEvent = (status) => {

    const data = {
      "ID": this.state.eventId,
      "post_status": status,
      "blog_id": this.state.eventDetails.country?.id || this.state.eventDetails.select_country.id
    };

    EventService.updateStatus(data).then((result) => {
      result.data === 200 ? (
        ToastService.success(result.data.message),
        window.history.back()) :
        (ToastService.error(result.data.message), window.history.back());

    });

  };

  render() {
    const { eventDetails, buttonDisabled } = this.state;
    return (
      <div className="container-fluid" id="main">
        {/* <div className="row d-flex align-items-center justify-content-center">
          <div className="col-md-9 mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="#">Home</a></li>
                <li className="breadcrumb-item active" aria-current="page">Event</li>
              </ol>
            </nav>
          </div>
          <div className="col-md-3 text-end mt-4">
            <span className="text-primary" onClick={() => window.history.back()}><i className="fa fa-angle-double-left" aria-hidden="true"></i> Back</span>
          </div>
        </div>
        <hr></hr> */}
        <div className="row">
          <div className="col-12">
            {/* <ul className="nav nav-tabs admintabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="view-all-events-tab" data-bs-toggle="tab" data-bs-target="#view-all-events-pane" type="button" role="tab" aria-controls="view-all-events-pane" aria-selected="true">View Events <span className="badge text-bg-secondary rounded-circle p-2">30</span></button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="add-new-events-tab" data-bs-toggle="tab" data-bs-target="#add-new-events-pane" type="button" role="tab" aria-controls="add-new-events-pane" aria-selected="false">Add New Events</button>
              </li>
            </ul> */}
          </div>
        </div>
        <div className="tab-content bg-white p-3 " id="myTabContent">
          <div className="tab-pane fade show active" id="view-all-events-pane" >

            <div className="rw mt-3 bg-white p-3">

              <div className=" event-title">
                <h4>{eventDetails?.post_title}</h4>
              </div>

              {buttonDisabled ? '' : <div className="evdttopbtn text-end">
                <Link to={{
                  pathname: "/super/update-event",
                  search: `?id=${eventDetails?.ID}`,
                  state: { editData: eventDetails }
                }} className="btn theme-btn-outline flg ">Edit Event Detail
                </Link>
                {eventDetails.post_status === 'pending' ? <button type="button" className="btn theme-btn-outline flg" onClick={() => this.onApproveDisapproveEvent('publish')}>
                  Approve
                </button> :
                  <button type="button" className="btn theme-btn-outline flg " onClick={() => this.onApproveDisapproveEvent('pending')}>
                    Disapprove
                  </button>}
              </div>}

            </div>

            <div className="row bg-white p-3">
              <div className="card p-0 border rounded rounded-4">
                <div className="col-12">
                  <div id="carouselExample" className="carousel slide">
                    <div className="carousel-inner">
                      <div className="carousel-item active evimbg">
                        {eventDetails?.event_image?.length > 0 && <img src={eventDetails?.event_image[0]} className="img-fluid d-block w-100 rounded rounded-4 evtdetimg" alt="events" />}
                      </div>
                      {/* <div className="carousel-item">
                        <img src={require('../../../public/cityevents.jpg')} className="img-fluid d-block w-100 rounded rounded-4" alt="events" />
                      </div>
                      <div className="carousel-item">
                        <img src={require('../../../public/cityevents.jpg')} className="img-fluid d-block w-100 rounded rounded-4" alt="events" />
                      </div> */}
                    </div>
                    {/* <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                      <span className="carousel-control-next-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Next</span>
                    </button> */}
                  </div>
                </div>

                <div className="evhdcontain mt-3 mb-3 p-4">

                  <div className="eventheadtext_outr">
                    <div className="date-card">
                      <div className="month w-100">{moment(eventDetails?.date_of_event || eventDetails?.start_date)?.format("MMM")}</div>
                      <div className="day d-block w-100">{moment(eventDetails?.date_of_event || eventDetails?.start_date)?.format("DD")}</div>
                      <div className="status d-block w-100">{eventDetails?.post_status === "pending" ? "Pending" : "Approved"}</div>
                    </div>
                    <div className="eventheadtext">
                      <h4>{eventDetails?.post_title}</h4>
                      by <span className="evdoctrnam fw-bold mb-2"> {eventDetails?.practitioner_name}</span>
                      <b className="eve-date d-block my-2">{moment(eventDetails.date_of_event)?.format("Do MMM YYYY")}</b>
                    </div>
                  </div>
                  {/* below is like btn */}
                  {/* <div className="twobtns">
                    <span className="badge bg-white border rounded rounded-3 p-2 px-4 text-dark share-btn">
                      <img src={hearticn} className="shicn" alt="like heart Icon" />
                      857
                    </span>
                    <div className="share-button sharer">
                      <span className="badge bg-white border rounded rounded-3 p-2 px-4 text-dark share-btn">
                        <img src={shareicn} className="shicn" alt="share icon" />
                        Share
                      </span>
                    </div>
                  </div> */}

                </div>
              </div>

            </div>
            <div className="row bg-white p-3">
              <div className="col-md-8 mb-3">
                <div className="card p-3 rounded rounded-4">
                  <h5>{eventDetails?.post_title}</h5>
                  <span className="text-primary fw-bold">{moment(eventDetails?.date_of_event || eventDetails?.start_date)?.format("ddd MMM DD  YYYY")}  {moment(eventDetails?.time_of_event || eventDetails?.start_time, ["HH:mm"]).format("hh:mm A")}  </span>
                  <div className="eve-des mt-4">
                    <p>
                      {eventDetails?.post_title}
                    </p>
                    <div dangerouslySetInnerHTML={{ __html: eventDetails?.post_content }} />
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="card p-3 rounded rounded-4">
                  <div className="domains">
                    <h5>Domains</h5>
                    {eventDetails?.category?.length > 0 && eventDetails?.category?.map((item, index) => <span key={index} className="badge rounded-pill text-bg-morelight fw-normal mt-4">{item.name}</span>)}

                  </div>
                  <div className="eve-address mt-4">
                    <h5>More Details about event</h5>
                    <b>Event Venue</b>
                    <span className="d-block">
                      {eventDetails?.center_address ? (eventDetails?.center_address + ',') : ''}  {eventDetails?.select_state ? eventDetails?.select_state + ',' : ''}  {eventDetails?.select_country?.blogname}
                    </span>
                  </div>
                  <div className="eve-time mt-4">
                    <span>{moment(eventDetails?.date_of_event || eventDetails?.start_date)?.format("ddd MMM DD  YYYY")}  {moment(eventDetails?.time_of_event || eventDetails?.start_time, ["HH:mm"]).format("hh:mm A")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="tab-pane fade" id="add-new-events-pane" role="tabpanel" aria-labelledby="add-new-events">
            <CreateEvent />
          </div> */}
        </div>
      </div>
    );
  }
}
export default EventDetails;